import {
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  FormsModule
} from '@angular/forms';

import {
  ActivatedRoute
} from '@angular/router';

import Swal from 'sweetalert2';

import {
  finalize
} from 'rxjs';

import {
  AvaliacaoService,
  AvaliacaoResponse
} from '../../service/avaliacao.service';

@Component({
  selector: 'app-avaliacao',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './avaliacao.component.html',
  styleUrls: ['./avaliacao.component.css']
})
export class AvaliacaoComponent implements OnInit {

  token = '';

  avaliacao: AvaliacaoResponse | null = null;

  nota = 0;

  comentario = '';

  carregando = true;

  enviando = false;

  erro = '';

  constructor(
    private route: ActivatedRoute,
    private avaliacaoService: AvaliacaoService,
    private cdr: ChangeDetectorRef
  ) {}


  ngOnInit(): void {

    this.token =
      this.route.snapshot.paramMap.get('token') || '';

    if (!this.token) {

      this.erro =
        'Link de avaliação inválido.';

      this.carregando = false;

      return;
    }

    this.buscarAvaliacao();
  }


  buscarAvaliacao(): void {

    this.carregando = true;
    this.erro = '';

    this.avaliacaoService
      .buscarPorToken(this.token)
      .pipe(
        finalize(() => {

          this.carregando = false;

          this.cdr.detectChanges();

        })
      )
      .subscribe({

        next: (resposta) => {

          this.avaliacao = resposta;

          this.nota = resposta.nota ?? 0;

          this.comentario =
            resposta.comentario ?? '';

        },

        error: (erro) => {

          this.erro =
            erro?.status === 404
              ? 'Esta avaliação não foi encontrada.'
              : 'Não foi possível carregar sua avaliação.';

        }

      });
  }


  selecionarNota(nota: number): void {

    this.nota = nota;
  }


  enviar(): void {

    if (this.nota === 0) {

      Swal.fire({
        icon: 'warning',
        title: 'Avaliação incompleta',
        text: 'Selecione uma nota de 1 a 5 estrelas.'
      });

      return;
    }

    this.enviando = true;


    this.avaliacaoService
      .enviarAvaliacao(
        this.token,
        {
          nota: this.nota,
          comentario: this.comentario.trim()
        }
      )
      .subscribe({

          next: (resposta) => {

            this.enviando = false;

            this.avaliacao = resposta;

            Swal.fire({
              icon: 'success',
              title: 'Obrigado pela avaliação!',
              text: 'Sua opinião é muito importante para nós.',
              confirmButtonText: 'Concluir'
            });

            this.cdr.detectChanges();
          },

        error: (erro) => {

          this.enviando = false;

          Swal.fire({
            icon: 'error',
            title: 'Não foi possível enviar',
            text: 'Tente novamente em alguns instantes.'
          });

          this.cdr.detectChanges();
        }

      });
  }
}
